import { Component, OnInit, ViewChild } from '@angular/core';
import { SearchFilter, IFilterResponse } from 'src/app/infrastructure/iFilter-component';
import { MedicalFeeSearchItem } from 'src/app/model/medical-fee/medical-fee-search-item';
import { MatTableDataSource, MatDialog } from '@angular/material';
import { SearchFilterComponent } from '../../search-filter/search-filter.component';
import { PagerControlComponent } from '../../controls/pager/pager-control.component';
import { Router } from '@angular/router';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { MenuService } from 'src/app/services/menu.service';
import { MedicalFeeService } from 'src/app/services/medical-fee/medical-fee.service';
import { ReportViewerDialogComponent } from '../../dialogs/report-viewer/report-viewer-dialog/report-viewer-dialog.component';

@Component({
  selector: 'app-medical-fee-search',
  templateUrl: './medical-fee-search.component.html',
  styleUrls: ['./medical-fee-search.component.css']
})
export class MedicalFeeSearchComponent {

  loading: boolean;
  loadingAction: boolean;
  searchFilters: SearchFilter[];
  displayedColumns: string[] = ['Number', 'Amount', 'Date',
                                'MedicalFeePeriodName', 'PayDate',
                                'Action'];
  medicalFeeSearchItems: MedicalFeeSearchItem[] = [];
  dataSource = new MatTableDataSource([]);
  @ViewChild('searchFilter', {static: false}) searchFilter: SearchFilterComponent;
  @ViewChild('pager', {static: true}) pager: PagerControlComponent;

  constructor(public dialog: MatDialog,
     private medicalFeeService: MedicalFeeService,
     private notificationToastService: NotificationToastService,
      private menuService: MenuService) {
    this.menuService.setMenuTitle('Honorarios', 'Búsqueda');
  }

  selectedPageIndexChange(pagedItems: any[]) {
    this.dataSource = new MatTableDataSource(pagedItems);
    this.loading = false;
  }

  onEndSearch(response: IFilterResponse<MedicalFeeSearchItem>) {
    this.medicalFeeSearchItems = response.items;
    this.searchFilters = response.searchFilters;
    this.pager.setItems(this.medicalFeeSearchItems);
  }

  onStartSearch() {
    this.loading = true;
  }

  async viewReport(medicalFeeSearchItem: MedicalFeeSearchItem) {
    try {
      this.loadingAction = true;
      const reportViewer = await this.medicalFeeService
            .getMedicalFeeReport(medicalFeeSearchItem.Id, medicalFeeSearchItem.IsManual);
      this.dialog.open(ReportViewerDialogComponent, {
        width: '90%',
        height: '600px',
        data: reportViewer
      });
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Honorarios');
    } finally {
      this.loadingAction = false;
    }
  }
}
